<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'source-site',
  },
})

import { type } from '@/datas/sites'
import { getProjectId } from "@/utils/cdms"
import { VDataTable } from 'vuetify/labs/VDataTable'

const { t } = useI18n()
const projectLocked = ref(await isLockedProject())
const search = ref('')

const serverItems = ref([])
const page = ref(1)
const itemsPerPage = ref(10)

// Data table Headers
const headers = [
  {
    title: t('Site ID'),
    key: 'site_no',
    width: "10%",
  },
  {
    title: t('Site Name'),
    key: 'name',
    width: "30%",
  },
  {
    title: t('Contract date'),
    key: 'contract_date',
    width: "20%",
  },
  {
    title: t('Phone'),
    key: 'phone',
  },
  {
    title: t('Type'),
    key: 'type',
  },
  {
    title: t('Edit'),
    key: 'actions',
    sortable: false,
    width: "120px",
  },
]

const typeData = type

const loadItems = async() => {

  const { data, error } = await useApi(createUrl('/sources/sites', {
    query: {
      projectId: getProjectId(),

      // q: searchQuery,
      // itemsPerPage,
      // page,
      // sortBy: sortBy[0]?.key ?? 'site_no',
      // orderBy: sortBy[0]?.order ?? 'desc',
    },
  }))

  if (error.value) {
    console.error(error.value)
  } else {
    if (data.value) {
      serverItems.value = data.value
    }
  }

}

loadItems()

const filterItems = [
  { value: "name", title: "기관명" },
  { value: "phone", title: "연락처" },
]

const filterItem = ref('name')

const filterText = (value, query, item) => {
  return value != null &&  query != null &&
        typeof value === 'string' &&
        item.columns[filterItem.value].toLowerCase().indexOf(query.toLowerCase()) !== -1
}

const typeText = val => {
  return typeData.find(({ value }) => value == val).text
}

const deleteItem = async item => {
  const result = await $api(`/sources/sites/${item.project_sites_id}`, { method: 'DELETE',
    body: {  } })

  loadItems()
}
</script>

<template>
  <h3 class="text-lg font-semibold mb-8">
    기관 등록
  </h3>
  <VCard>
    <VCardText>
      <div class="d-flex justify-space-between flex-wrap gap-y-4">
        <div />
        <div class="d-flex flex-row align-center flex-wrap">
          <AppSelect
            v-model="filterItem"
            :items="filterItems"
            style="inline-size:150px;"
          />
          <AppTextField
            v-model="search"
            class="pe-4"
            style="max-inline-size: 200px; min-inline-size: 200px;"
            :placeholder="$t('Search') + '...'"
            density="compact"
          />
          <VBtn
            prepend-icon="tabler-plus"
            color="success"
            :disabled="projectLocked"
            @click="$router.push('/sources/sites/create')"
          >
            {{ $t('Add Site') }}
          </VBtn>
        </div>
      </div>
    </VCardText>
    <VCardText>
      <VDataTable
        v-model:items-per-page="itemsPerPage"
        v-model:page="page"
        :items="serverItems"
        :headers="headers"
        :search="search"
        class="custom-table"
        :custom-filter="filterText"
        density="compact"
      >
        <template #item.type="{ item }">
          <VChip
            class="font-weight-medium"
            size="small"
            color="primary"
          >
            {{ typeText(item.type) }}
          </VChip>
        </template>
        <!-- Actions -->
        <template #item.actions="{ item }">
          <div class="d-flex gap-1">
            <IconBtn
              :disabled="projectLocked"
              @click="$router.push({ name: 'sources-sites-edit-id', params: {id:item.project_sites_id} })"
            >
              <VIcon icon="tabler-edit" />
              <VTooltip
                activator="parent"
                location="top"
              >
                수정
              </VTooltip>
            </IconBtn>
            <IconBtn
              :disabled="projectLocked"
              @click="deleteItem(item)"
            >
              <VIcon
                icon="tabler-trash"
                color="error"
              />
              <VTooltip
                activator="parent"
                location="top"
              >
                삭제
              </VTooltip>
            </IconBtn>
          </div>
        </template>
        <!--
          <template #bottom>
          <div class="d-flex align-center justify-sm-space-between justify-center flex-wrap gap-3 pa-5 pt-3">
          <p class="text-sm text-disabled mb-0">
          {{ paginationMeta({ page, itemsPerPage }, totalItems) }}
          </p>
          <VSpacer />
          <div class="d-flex flex-row gap-4 align-center flex-wrap">
          <span class="text-sm font-weight-medium">Items per page:</span>
          <AppSelect
          v-model="itemsPerPage"
          density="compact"
          :items="[5, 10, 20, 50, 100]"
          />
          </div>
          <VPagination
          v-model="page"
          :total-visible="$vuetify.display.smAndDown ? 3 : 5"
          :length="pageCount"
          />
          </div>
          </template>
        -->
      </VDataTable>
    </VCardText>
  </VCard>
</template>

<style lang="scss" scoped>
:deep(.custom-table .v-table__wrapper table) {
  th {
    background: #F3F5F8 !important;  /* 밝은 회색 배경 */
    border-block-end: 1px solid #eee;
    color: #909090 !important;       /* 연한 회색 텍스트 */
    font-size: 13px;
    font-weight: 500;
    padding-block: 10px;
    padding-inline: 12px;
  }

  td {
    border-block-end: 1px solid #E8EBEE;
    color: #444;
    font-size: 14px;
    padding-block: 8px;
    padding-inline: 12px;
  }

  tr:hover td {
    background-color: #f9f9fc; /* hover 시 은은한 하이라이트 */
  }
}

:deep(.custom-table .v-badge__badge) {
  border-radius: unset;
  font-size: 8px;
  margin-inline-start: 5px;
  min-inline-size: 10px;
}

:deep(.v-card-item) {
  padding: 12px;
}
</style>
